// ABOUTME: Configuration for the API Connections page in the relation environment.
// ABOUTME: Defines tab titles, icons, and grid options for the API connections data grid.

import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';

export const relationApiConnectionsConfig = {
    all: {
        title: 'api_connections',
        subtitle: 'api_connections',
        icon: <ApiOutlinedIcon/>,
        isSingleDataGrid: true,
    }
};
